module.exports = __webpack_public_path__ + "media/customizations/austinpoint/back-0949c343c6a19f6d459bd214180028a6.jpg";